
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Ω / Icons / platforms / android","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 23.333 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.6 28a1.756 1.756 0 01-1.762-1.7v-4.133H10.5V26.3a1.669 1.669 0 01-.517 1.2A1.758 1.758 0 017 26.3v-4.133h-.516a1.818 1.818 0 01-1.817-1.815V9.334h14v11.015a1.818 1.818 0 01-1.815 1.817h-.518V26.3a1.669 1.669 0 01-.516 1.2 1.745 1.745 0 01-1.218.5zm6.988-8.166a1.708 1.708 0 01-1.75-1.659v-7.124a1.75 1.75 0 013.5 0v7.125a1.708 1.708 0 01-1.755 1.658zm-19.834 0A1.708 1.708 0 010 18.175v-7.124a1.75 1.75 0 013.5 0v7.125a1.708 1.708 0 01-1.75 1.658zM18.667 8.165h-14a6.223 6.223 0 013.557-5.646L7.127.35a.252.252 0 01.009-.245A.21.21 0 017.317 0a.213.213 0 01.191.122l1.108 2.192a7.2 7.2 0 016.1 0L15.825.122A.216.216 0 0116.016 0a.209.209 0 01.184.1.252.252 0 01.009.245l-1.1 2.169a6.223 6.223 0 013.558 5.646zm-4.085-3.5a.583.583 0 10.584.583.583.583 0 00-.584-.581zm-5.831 0a.583.583 0 10.582.583.584.584 0 00-.582-.581z","fill":"#011936"}})])
          )
        }
      }
    